export class ResourceIdentifiers {
    'id';
    'providerId';
    'name';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "providerId",
            "baseName": "providerId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ResourceIdentifiers.attributeTypeMap;
    }
    constructor() {
    }
}
